import { MediaItem } from 'Interfaces/general.interface';
import ComponentVideo from "GeneralComponents/ComponentVideo";

interface Props {
    image: MediaItem;
    mobileImage: MediaItem;
    imageClass?: string;
    mobileImageClass?: string;
    wrapperDivClass?: string;
    cropAlias?: keyof MediaItem;
    videoControls?: boolean;
    videoAutoplay?: boolean;
    cancelVideoLoop?: any;
    onVideoEnded?: any;
}

const ComponentImage: React.FC<Props> = (props) => {

    const { cancelVideoLoop, imageClass, onVideoEnded, cropAlias, videoAutoplay, videoControls, wrapperDivClass, mobileImageClass } = props;

    const image = handleCropImg(props.image, cropAlias);
    const mobileImage = handleMobileImage(props.image, props.mobileImage, cropAlias);

    function handleMobileImage(img: MediaItem, mobileImg: MediaItem, cropAlias: typeof props.cropAlias): MediaItem {

        const validMobileImage = mobileImg && mobileImg.url ?{ ...mobileImg }: { ...img };

        return handleCropImg(validMobileImage, cropAlias);

    }

    function handleCropImg(image: MediaItem, cropAlias: typeof props.cropAlias): MediaItem {

        if (cropAlias && image[cropAlias]) {

            const croppedImgUrl = image[cropAlias] as string;

            return { ...image, url: croppedImgUrl }
        }

        return image;
    }


    // Case no image provided
    if (!image.url) {
        return <div className={wrapperDivClass}></div>;
    }

    return (
        <figure className={wrapperDivClass}>

            {
                image.isImage ?

                <img
                    src={image.url}
                    alt={image.alt}
                    className={`d-none d-md-block d-lg-block ${imageClass}`}
                />

                :

                <ComponentVideo
                    video={image}
                    videoClass={`d-none d-md-block d-lg-block video-fluid ${imageClass}`}
                    withControls={videoControls}
                    autoPlay={videoAutoplay}
                    cancelLoop={cancelVideoLoop}
                    onVideoEnded={onVideoEnded}
                />
            }

            {

                mobileImage.isImage ?

                    <img
                        src={mobileImage.url}
                        alt={mobileImage.alt}
                        className={`d-lg-none d-md-none ${mobileImageClass}`}
                    />

                :

                <ComponentVideo
                    video={mobileImage}
                    videoClass={`d-block d-md-none d-lg-none video-fluid ${mobileImageClass}`}
                    withControls={videoControls}
                    autoPlay={videoAutoplay}
                    cancelLoop={cancelVideoLoop}
                    onVideoEnded={onVideoEnded} />

            }

        </figure>

    );
}

export default ComponentImage;
